import Link from '@mui/material/Link';
import { useSelector } from 'react-redux';
import { selectRefreshToken } from '../../store/user/selectors';
import { useMemo } from 'react';
import {
  APPS_PATH,
  LOGIN_PATH,
  LOGOUT_PATH,
  PRICING_PATH,
  ROUTER_BASE_PATH,
} from '../../constants';
import {
  StyledContainer,
  StyledLink,
  StyledLinksContainer,
  StyledLoginButton,
  StyledLogoContainer,
  StyledLogoImage,
  StyledLogoLabel,
} from './styled';

const Header = () => {
  const token = useSelector(selectRefreshToken);

  return (
    <StyledContainer>
      <StyledLogoContainer href={ROUTER_BASE_PATH}>
        <StyledLogoImage />
        <StyledLogoLabel>for developers</StyledLogoLabel>
      </StyledLogoContainer>
      <StyledLinksContainer>
        <StyledLink to={PRICING_PATH}>Pricing</StyledLink>
        <StyledLink to={'/'}>API Playground</StyledLink>
        <StyledLink to={APPS_PATH}>My Apps</StyledLink>
        {token ? (
          <StyledLoginButton
            // @ts-expect-error component is actually handled correctly here
            component={Link}
            href={`${LOGOUT_PATH}?redirect=${ROUTER_BASE_PATH}`}
          >
            Log Out
          </StyledLoginButton>
        ) : (
          <StyledLoginButton
            // @ts-expect-error component is actually handled correctly here
            component={Link}
            href={`${LOGIN_PATH}?redirect=${ROUTER_BASE_PATH}&registerRedirect=${ROUTER_BASE_PATH}${APPS_PATH}`}
          >
            Log In
          </StyledLoginButton>
        )}
      </StyledLinksContainer>
    </StyledContainer>
  );
};

export default Header;
